export default "__VITE_PUBLIC_ASSET__ddd5adc9__"